export default function priceFormatter(sum: string | number) {
    const num = typeof sum === "string" ? Number(sum.replace(/\s/g, "")) : sum;
    const roundedSum = num.toFixed(2);
    const [integerPart, decimalPart] = roundedSum.split(".");
    const sign = num < 0 ? "-" : "";

    const absoluteIntegerPart = Math.abs(parseInt(integerPart)).toString();
    const formattedInteger = absoluteIntegerPart.replace(
        /\B(?=(\d{3})+(?!\d))/g,
        " ",
    );

    return `${sign}${formattedInteger}.${decimalPart}`;
}
